import { Container } from "react-bootstrap";
import { useState, useEffect } from "react";
import { FadeLoader } from "react-spinners";

import Service from "../../Service/http";
import { toast } from "react-toastify";
const service = new Service();

export default function EditFormula() {
  const [siteName, setSiteName] = useState("");
  const [loading, setLoading] = useState(false);
  const [scoreFields, setScoreFields] = useState({});
  const [currentFormula, setCurrentFormula] = useState({});
  const [formulas, setFormulas] = useState({});
  const [siteOptions, setSiteOptions] = useState([]);
  const [saved, setSaved] = useState(true);

  const handleFormulaChange = (event) => {
    let { name, value } = event.target;
    value = parseFloat(value)
    setSaved(false);
    setCurrentFormula({ ...currentFormula, [name]: value });
  };

  const updateFormula = () => {
    service
      .put("api/leaderboard/formula", { siteName, attributes: currentFormula })
      .then(() => {
        toast.success("Formula Updated");
        getFormulaData()
      })
      .catch((err) => {
        toast.error("error");
        console.log(err);
      });
  };

  const getFormulaData = async () => {

    setLoading(true);
    try{
      const data = await service.get("api/leaderboard/formula")
      setFormulas(data.formula);
      setScoreFields(data.scoreFields);
      setSiteName(Object.keys(data.scoreFields)[0]);
      setCurrentFormula(data.formula[Object.keys(data.scoreFields)[0]]);
      setSiteOptions(Object.keys(data.scoreFields));
      setSaved(true);
    } catch(error){
      console.log(error)
    } finally{
      setLoading(false)
    }
  };
  useEffect(() => {
    getFormulaData();
  }, []);

  if (loading)
    return (
      <div className="text-center">
        <FadeLoader color={"green"} />
      </div>
    );

  const rows = scoreFields[siteName]?.map((row, ind) => {
    return (
      <tr key={ind}>
        <td className="text-secondary text-center">{ind + 1}</td>
        <td className="text-secondary ">{row}</td>
        <td className="text-secondary">
          <input
            className="form-control text-primary font-monospace"
            type="number"
            name={row}
            step="any"
            value={currentFormula[row]}
            onChange={handleFormulaChange}
          />
        </td>
      </tr>
    );
  });
  // const rows = []
  return (
    <Container>
      <h1 className="text-center mt-4 text-primary">Edit Formula</h1>
      <select
        className="form-select text-primary mt-3 mb-1 w-25"
        style={{minWidth:"300px"}}
        value={siteName}
        onChange={(e) => {
          if (saved) {
            setSiteName(e.target.value);
            setCurrentFormula(formulas[e.target.value]);
          } else {
            toast.info("Please Save Your Changes First");
          }
        }}
      >
        {siteOptions?.map((ele, ind) => {
          return (
            <option key={ind} value={ele}>
              {ele}
            </option>
          );
        })}
      </select>
      <table id="customers">
        <thead>
          <tr className="bg-light text-center ">
            <th className="text-center">S.No</th>
            <th className="text-center">Column Name</th>
            <th className="text-center">Formula</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
      <div className="me-5 mb-4 mt-4">
        <button
          type="submit"
          className="btn btn-primary float-end px-5"
          onClick={updateFormula}
        >
          Update Formula
        </button>
      </div>
      <div className="form-label text-primary mt-4 text-start">
        {" "}
        NOTE: Add more columns for score calculation by updating 'ScoreFields'
        in the <span className="text-danger"> backend:mapping.js </span>
      </div>
    </Container>
  );
}
